import { ThirdPartyScript } from "./thirdPartyScript";

const attentive = () => {
  return <ThirdPartyScript name="attentive" src="https://cdn.attn.tv/renttherunway/dtag.js"></ThirdPartyScript>;
};

export default attentive;
